import { render, staticRenderFns } from "./LawMatterProcessResultList.vue?vue&type=template&id=738d30e1&"
import script from "./LawMatterProcessResultList.vue?vue&type=script&lang=js&"
export * from "./LawMatterProcessResultList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterProcessResultList.vue?vue&type=style&index=0&id=738d30e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports